import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.css'

// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import VueTabulator from 'vue-tabulator';
Vue.component('VueTabulator', VueTabulator);

import YhFilters from '@/filters/index.js'
Vue.use(YhFilters);

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
